export default {
  "Page": "_Page_xnwsy_1",
  "Header": "_Header_xnwsy_12",
  "Title": "_Title_xnwsy_21",
  "SectionCard": "_SectionCard_xnwsy_28",
  "Content": "_Content_xnwsy_45",
  "CardTitle": "_CardTitle_xnwsy_53",
  "EngagementStatsWrapper": "_EngagementStatsWrapper_xnwsy_64"
};import "ni:sha-256;edujIWCEF67vzQ7T4TjQcL-Xw28g_rKG2T0gPkricik";